import * as yup from 'yup';

export const createSchema = (id?: string) => {
  let password = yup.string();
  let passwordConfirm = yup
    .string()
    .test(
      'passwords-match',
      'Passwords must match',
      (value, context) => context.parent.password === value,
    );

  if (!id) {
    password = password.required('Password is required');
    passwordConfirm = passwordConfirm.required('Password Confirmation is required');
  }
  return yup.object().shape({
    licenseeId: yup.number().required('Licensee id is required'),
    roleId: yup.string().required('Role is required'),
    email: yup.string().email().required('Email is required'),
    name: yup.string().required('Name is required'),
    title: yup.string().optional().nullable(),
    phone: yup.string().optional().nullable(),
    apiKey: yup.string().optional().nullable(),
    shortToken: yup.string().optional().nullable(),
    password,
    passwordConfirm,
    languageId: yup.number().required(),
    workPhone: yup.string().optional().nullable(),
    workEmail: yup.string().email().optional().nullable(),
    paymentHandle: yup.string().optional().nullable(),
    paymentNotes: yup.string().optional().nullable(),
    contactType: yup
      .number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .nullable(),
    referralCompanyId: yup.number().nullable(),
    salesLevel: yup
      .number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .nullable(),
    salesGroup: yup.string().optional().nullable(),
    maxLeads: yup
      .number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .nullable(),
    payPercentage: yup
      .number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .nullable(),
    skip: yup.bool().default(false),
    dripActive: yup.bool().default(false),
    details: yup.object().shape({
      description: yup.string().optional().nullable(),
    }),

    w9: yup.mixed().nullable(), // TODO: add validation when requirements are clear
    avatar: yup.mixed().nullable(), // TODO: add validation when requirements are clear
  });
};
export type Schema = yup.InferType<ReturnType<typeof createSchema>>;
